<script>
  import { app_user } from '../Users/observables'
  import { state } from '../Game/State'
  import AdminButtons from './Buttons/Admin.svelte'
  import LeaderButtons from './Buttons/Leader.svelte'
  import Logout from '../Users/Logout.svelte'
  import PlayerButtons from './Buttons/Player.svelte'
  export let mobile = false
</script>

<div class:mobile>
  {#if $app_user.state === 'NoSubscription' || $app_user.state === 'UnverifiedEmail'}
    <Logout />
  {:else if $app_user.state === 'LapsedSubscription'}
    <Logout />
  {:else if $app_user.state === 'Authed'}
    {#if $app_user?.role === 'Admin'}
      <AdminButtons />
    {:else if $app_user?.uid === $state?.leader}
      <LeaderButtons />
    {:else}
      <PlayerButtons />
    {/if}
  {/if}
</div>

<style>
  .mobile {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    row-gap: 1em;
    margin: 1em 0em 1em 0em;
  }
</style>
